import React, { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import { formatarData } from '../../../utils/formatadorDataTabela'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import Table from '../../Table/index.jsx'

import BloquearCliente from './bloquearCliente/bloquearCliente'
import EnviarAviso from './enviarAviso/enviarAviso'
import RemoverBloqueio from './removerBloqueio/removerBloqueio'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let dadosSelecionados = []
let itensVar = []
let valorLimite = 50

const TableprimaryKey = 'cd_pav_cliente_bloqueio'

function TabelaBloqueio() {
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [dadosParaDownload, setDadosParaDownload] = useState([])
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [itensSelecionados, setItensSelecionados] = useState([])

  const despacho = useDispatch()

  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)

  const solicitacaBloquearVirtueyes = useSelector(
    (state) => state.virtueyesState.solicitacaBloquearVirtueyes
  )
  const solicitacaRemoverBloqueioVirtueyes = useSelector(
    (state) => state.virtueyesState.solicitacaRemoverBloqueioVirtueyes
  )
  const solicitacaEnviarAvisoVirtueyes = useSelector(
    (state) => state.virtueyesState.solicitacaEnviarAvisoVirtueyes
  )
  const solicitacaExportarVirtueyes = useSelector(
    (state) => state.virtueyesState.solicitacaExportarVirtueyes
  )

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(447) // 'solicitacaoBloqueioTabela'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
  }, [])

  useEffect(() => {
    if (solicitacaExportarVirtueyes) {
      handlerOrdenarDadosExportar()
    }
  }, [solicitacaExportarVirtueyes])

  async function handlerOrdenarDadosExportar() {
    await Promise.all(
      dadosSelecionados.map((item_dadosSelecionados, i) => {
        dadosParaDownload.push({
          'Cód.cliente': item_dadosSelecionados.n0_codigo_cliente,
          'Razão social': item_dadosSelecionados.ds_pav_cliente,
          // Comentado pois a michele maciel requisitou
          // "Nome fantasia":item_dadosSelecionados.ds_nome_fantasia,
          // "E-mail":item_dadosSelecionados.ds_email,
          // "Telefone":item_dadosSelecionados.ds_telefone,
          // 'Usuário':item_dadosSelecionados.ds_pav_usuario_email,
          Data: item_dadosSelecionados.dt_created_at,
          Status: item_dadosSelecionados.fl_acao === 1 ? 'Bloqueado' : 'Ativo'
        })
        if (item_dadosSelecionados.fl_acao == 1) {
          dadosParaDownload[i]['Status'] = 'Bloqueado'
        } else {
          dadosParaDownload[i]['Status'] = 'Ativo'
        }
      })
    ).then(() => {
      setDadosParaDownload(JSON.parse(JSON.stringify(dadosParaDownload)))
    })
    setTimeout(() => {
      //aciona o event click para o ativar o download do arquivo
      const exportar = document.getElementById('exportar-detalhamento-bloqueio')
      exportar.click()
      // despacho(revelarSolicitacaExportarVirtueyes(false));
    }, 250)
  }

  useEffect(() => {
    setSpinAtivo(true)
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(true))
    despacho(mudarManejador('solicitacaoBloqueio'))
    dadosSelecionados = []
    async function carregarTabela() {
      // //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/cliente_bloqueio?paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&buscar=' +
              conteudoBusca +
              '&fl_acao=1'
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros
        }

        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/cliente_bloqueio',
            dados
          )
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/cliente_bloqueio?paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&fl_acao=1'
          )
          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  const colunas = [
    {
      dataField: 'cd_pav_cliente',
      headerClasses: 'nao-selecionavel',
      text: 'Cód. cliente',
      hidden: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'n0_codigo_cliente',
      headerClasses: 'nao-selecionavel',
      text: 'Cód. cliente',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_pav_cliente',
      headerClasses: 'nao-selecionavel',
      text: 'Razão social',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_nome_fantasia',
      headerClasses: 'nao-selecionavel',
      text: 'Nome fantasia',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_email',
      headerClasses: 'nao-selecionavel',
      text: 'E-mail',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_telefone',
      headerClasses: 'nao-selecionavel',
      text: 'Telefone',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'fl_acao',
      headerClasses: 'nao-selecionavel',
      text: 'Status',
      sort: true,
      formatter: (cell) => {
        if (cell === 1) {
          return <p className="fonte-cor-1 label-tabela-1">Bloqueado</p>
        } else if (cell === 0) {
          return <p className="fonte-cor-1 label-tabela-1">Ativo</p>
        } else {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        }
      }
    },
    {
      dataField: 'ds_pav_usuario_email',
      headerClasses: 'nao-selecionavel',
      text: 'Usuário',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'dt_created_at',
      headerClasses: 'nao-selecionavel',
      text: 'Data',
      sort: true,
      formatter: (cell) => {
        return formatarData(cell)
      }
    }
  ]

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  function handleSelecionarTodos() {
    ColetaClickstream(454) // 'solicitacaoBloqueioTabelaHandleSelecionarTodos'
    itens.map((item, i) => {
      if (itens[i].cd_pav_cliente_bloqueio) {
        dadosSelecionados.push(itens[i])
      }
    })
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  function handleDesselecionarTodos() {
    ColetaClickstream(455) // 'solicitacaoBloqueioTabelaHandleDesselecionarTodos'
    dadosSelecionados = []
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(true))
  }

  function handleSelecionar(simcard) {
    ColetaClickstream(456) // 'solicitacaoBloqueioTabelaHandleSelecionar'
    for (let i = 0; i < itens.length; i++) {
      if (itens[i].cd_pav_cliente_bloqueio === simcard) {
        dadosSelecionados.push(itens[i])
        break
      }
    }
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  function handleDesselecionar(simcard) {
    for (let i = 0; i < dadosSelecionados.length; i++) {
      if (dadosSelecionados[i].cd_pav_cliente_bloqueio === simcard) {
        dadosSelecionados.splice(i, 1)
        break
      }
    }
    if (dadosSelecionados.length == 0) {
      despacho(desabilitarAcoes(true))
      despacho(desabilitarAcoesCliente(true))
    }
  }

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual && filtros.vazio) {
      apiData = await api_gateway.get(
        '/m1/consultar/cliente_bloqueio?contar=true&buscar=' +
          conteudoBusca +
          '&fl_acao=1'
      )
    } else {
      const dados = {
        paginaAtual: contador,
        carregarLimit: valorLimite,
        contar: true,
        buscar: conteudoBusca,
        filtros: filtros
      }
      apiData = await api_gateway.post('/m1/filtrar/cliente_bloqueio', dados)
    }
    if (apiData.data.dados) {
      totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
      totalItens = apiData.data.dados[0].CONTADOR
      for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
        arrayItens.push(i)
      }
      itensVar = arrayItens
    }
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados((prev) => [...prev, row[TableprimaryKey]])
      handleSelecionar(row.cd_pav_cliente_bloqueio)
    } else {
      setItensSelecionados((prev) =>
        prev.filter((id) => id !== row[TableprimaryKey])
      )
      handleDesselecionar(row.cd_pav_cliente_bloqueio)
    }
  }

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      const allIds = rows.map((r) => r[TableprimaryKey])

      setItensSelecionados((prev) => [...prev, ...allIds])

      handleSelecionarTodos()
    } else {
      setItensSelecionados((prev) =>
        prev.filter((id) => !rows.some((r) => r[TableprimaryKey] === id))
      )
      handleDesselecionarTodos()
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionados,
          modeSelection: 'checkbox',
          handleOnSelect,
          handleOnSelectAll
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {solicitacaBloquearVirtueyes === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <BloquearCliente
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {solicitacaRemoverBloqueioVirtueyes === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <RemoverBloqueio
              dadosSelecionados={dadosSelecionados}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {solicitacaEnviarAvisoVirtueyes === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <EnviarAviso
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      <CSVLink
        id="exportar-detalhamento-bloqueio"
        filename="Bloqueio.csv"
        className="d-none"
        data={dadosParaDownload}
      />
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
export default connect(mapStateToProps)(React.memo(TabelaBloqueio))
